import pi1Schema from '../pi1/pi1-schema-validators';
import { schema as pi2Schema } from '../pi2/pi2-validations';

const v = require('ui-validator');

// TODO-LATER clean up pi1 and pi2 response map as well, these renamings are scattered there

const restOfValidations = {
  agreements: pi1Schema.agreements,
  loanType: pi1Schema.loanType,
  loanAmount: pi1Schema.loanAmount,
  loanPurpose: pi1Schema.loanPurpose,
  experiments: pi1Schema.experiments,
  prescreenPayLoad: pi1Schema.prescreenPayLoad,
};

const getSuffix = ({ isCoBorrower = false, useCoBorrowerSuffixOnKeys = true } = {}) => {
  return {
    suffix: isCoBorrower ? 'Secondary' : '',
    suffixOnKeys: isCoBorrower && useCoBorrowerSuffixOnKeys ? 'Secondary' : '',
  };
};

const validations = {
  // for client validations
  getPersonalInfo({
    isCoBorrower = false,
    useCoBorrowerSuffixOnKeys = true /* TODO rethink? just for client side validation in summaryCard validateFields */,
  } = {}) {
    const { suffix, suffixOnKeys } = getSuffix({
      isCoBorrower,
      useCoBorrowerSuffixOnKeys,
    });
    return {
      ...(isCoBorrower
        ? {}
        : {
            [`additionalIncome${suffixOnKeys}`]: pi1Schema[`incomeAdditional${suffix}`],
            [`additionalCash${suffixOnKeys}`]: pi1Schema[`additionalCash${suffix}`],
          }),
      // TODO-LATER pi1pi2 submit in speedo gets these errs from pbs which makes sense - we are not sending those and street is renamed
      // errors":["FIRST_NAME_EMPTY","LAST_NAME_EMPTY","MISSING_STREET_ADDRESS","MISSING_DOB"
      [`income${suffixOnKeys}`]: pi1Schema[`income${suffix}`],
      [`homeStatus${suffixOnKeys}`]: pi1Schema[`homeStatus${suffix}`],
      [`homeStatusExpense${suffixOnKeys}`]: pi1Schema[`homeStatusExpense${suffix}`],
      [`street${suffixOnKeys}`]: pi1Schema[`streetAddress${suffix}`],
      [`city${suffixOnKeys}`]: pi1Schema[`city${suffix}`],
      [`state${suffixOnKeys}`]: pi1Schema[`state${suffix}`],
      [`zip${suffixOnKeys}`]: pi1Schema[`zip${suffix}`],
      [`primaryPhone${suffixOnKeys}`]: pi1Schema.primaryPhone, // pi1 does not ask for primary phone secondary. could consider pi2 primaryPhoneSecondary ?
      [`ssn${suffixOnKeys}`]: pi1Schema[`ssn${suffix}`],
      ...(isCoBorrower
        ? {
            [`firstName${suffixOnKeys}`]: pi1Schema[`firstName${suffix}`],
            [`lastName${suffixOnKeys}`]: pi1Schema[`lastName${suffix}`],
            [`email${suffixOnKeys}`]: pi1Schema[`email${suffix}`],
            [`monthBirth${suffixOnKeys}`]: pi1Schema[`monthBirth${suffix}`],
            // [`primaryPhone${suffixOnKeys}`]: pi2Schema[`primaryPhone${suffix}`], // Should we use the Secondary phone from pi2Schema
          }
        : {}),
    };
  },
  getWorkInfo({ isCoBorrower = false, employmentStatus = 'employed', useCoBorrowerSuffixOnKeys = true } = {}) {
    const { suffix, suffixOnKeys } = getSuffix({
      isCoBorrower,
      useCoBorrowerSuffixOnKeys,
    });
    employmentStatus = employmentStatus.toLowerCase();
    return {
      ...(isCoBorrower ? { ssnSecondary: pi2Schema.ssnSecondary } : {}),
      ...(['employed', 'selfemployed', 'part_time', 'contractor'].includes(employmentStatus)
        ? {
            [`employerName${suffixOnKeys}`]: pi2Schema[`employer${suffix}`], // this and addr only required for employed, part_time, but asked for self employed and contractor too. note this is the only skipIfMissing where it's not for pi locked

            [`workStreet${suffixOnKeys}`]: pi2Schema[`workAddress${suffix}`], // note the diff in the last 3 to prevent collision with pi1 fields referring to primary address
            [`workCity${suffixOnKeys}`]: pi2Schema[`city${suffix}`],
            [`workState${suffixOnKeys}`]: pi2Schema[`state${suffix}`],
            [`workZipCode${suffixOnKeys}`]: pi2Schema[`zipCode${suffix}`],
            [`workPhone${suffixOnKeys}`]: pi2Schema[`workPhone${suffix}`],
          }
        : {}),
      ...(['employed', 'part_time'].includes(employmentStatus)
        ? {
            [`tenure${suffixOnKeys}`]: pi2Schema[`tenure${suffix}`],
          }
        : {}),
      // [ `tenure${suffixOnKeys}` ]: pi2Schema.tenure, // TODO-LATER someday, same validations for all instead of ref different but almost same validations
      ...(employmentStatus === 'employed' ? { [`position${suffixOnKeys}`]: pi2Schema[`position${suffix}`] } : {}),
      [`employmentStatus${suffixOnKeys}`]: pi2Schema[`employmentStatus${suffix}`], // note for this and other fields, for pi2 locked we are always sending them so NOT skipIfMissing, but required! once we do pi locked, we will need to account for this
    };
  },
  ...restOfValidations,
  // others in PI1 schema?
};
// TODO fix skipIfMissing? - actually may be ok if we just initiate all values to empty str on client side, which would NOT skipIfMissing

const { street, city, state, zip, homeStatus, homeStatusExpense, primaryPhone, ssn, income, additionalIncome } =
  validations.getPersonalInfo();

const {
  firstNameSecondary,
  lastNameSecondary,
  primaryPhoneSecondary,
  emailSecondary,
  homeStatusSecondary,
  homeStatusExpenseSecondary,
  ssnSecondary,
} = validations.getPersonalInfo({
  isCoBorrower: true,
});

export const IncomeValidations = {
  income,
  additionalIncome,
};

export const coBorrowerValidations = {
  firstNameSecondary,
  lastNameSecondary,
  primaryPhoneSecondary,
  emailSecondary,
  // we are using primary validations for street/city/state/zip
  streetSecondary: street,
  citySecondary: city,
  stateSecondary: state,
  zipSecondary: zip,
  homeStatusSecondary,
  homeStatusExpenseSecondary,
  monthBirthSecondary: pi1Schema.monthBirth,
  dayBirthSecondary: pi1Schema.dayBirth,
  yearBirthSecondary: pi1Schema.yearBirth,
  ssnSecondary,
};

export const PIValidations = {
  // all except income
  street,
  city,
  state,
  zip,
  homeStatus,
  homeStatusExpense,
  primaryPhone,
  ssn,
};

const workInfoValidations = validations.getWorkInfo();

export const workSituationValidations = {
  // For employmentStatus, we are seeing differences in the error message shown between primary & secondary.
  // In this use case, we want to use the error message shown by Secondary
  'more-work': validations.getWorkInfo({
    isCoBorrower: true,
  }).employmentStatusSecondary,
  // the address needs to be not secondary
  streetAddress: street,
  city,
  state,
  zip,
  ...workInfoValidations,
};
export const workSituationValidationsCoborrower = {
  // we are reusing the primary work form, so no secondary suffix
  ...workSituationValidations,
  income,
  agreements: {
    required: (value, key, attrs) =>
      // custom validation added to overwrite the below message
      v.validators.required({ message: 'Checking the box to accept these terms and conditions is required' })(
        value,
        key,
        attrs
      ),
  },
};

export default validations;
export const flatValidations = {
  ...validations.getPersonalInfo(),
  ...validations.getPersonalInfo({ isCoBorrower: true }),
  ...validations.getWorkInfo(),
  ...validations.getWorkInfo({ isCoBorrower: true }),
  ...restOfValidations,
  dayBirthSecondary: true,
  yearBirthSecondary: true,
  prescreenEntryId: true,
  type: true,
  partnerData: true,
  experiments: true,
  trackingDataParams: true,
  monthlyPayment: true,
  showRentField: true,
};

